export const dialogMixin = {
  data: function () {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    toggle() {
      this.visible = !this.visible
    }
  }
}
